import { render, staticRenderFns } from "./unifiedCommand.vue?vue&type=template&id=48c7bb90&scoped=true&"
import script from "./unifiedCommand.vue?vue&type=script&lang=js&"
export * from "./unifiedCommand.vue?vue&type=script&lang=js&"
import style0 from "./unifiedCommand.vue?vue&type=style&index=0&id=48c7bb90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c7bb90",
  null
  
)

export default component.exports